import styled from 'styled-components';
import { Select } from 'antd';
import banner from '../../asset/images/Banner_Search.jpg';

export const Wrapper = styled.div`
  .button:hover span,
  button:hover span {
    color: inherit;
  }

  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const Header = styled.div`
  background-image: url(${banner});
  width: 100%;
  background-size: cover;
  padding: 55px;
`;

export const Content = styled.div`
  padding: 30px;
  max-width: 1366px;
  margin: 0 auto;
`;

export const SearchToolBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
`;

export const BooksContent = styled.div`
  min-height: 250px;
`;

export const SpinWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FullScreenSelect = styled(Select)`
  width: 100%; ;
`;

export const OperatorSelect = styled(Select)`
  width: 100px;
`;

export const StructureSelect = styled(Select)`
  width: 120px;
`;

export const FieldSelect = styled(Select)`
  width: 120px;
`;

export const ConditionList = styled.div``;

export const Title = styled.div`
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  margin-bottom: 20px;
  font-size: 36px;
  color: var(--title-blue);

  text-shadow: 0 1px 0 #ccc, 0 2px 0 #c9c9c9, 0 3px 0 #bbb, 0 4px 0 #b9b9b9,
    0 5px 0 #aaa, 0 6px 1px rgb(0 0 0 / 10%), 0 0 5px rgb(0 0 0 / 10%),
    0 1px 3px rgb(0 0 0 / 30%), 0 3px 5px rgb(0 0 0 / 20%),
    0 5px 10px rgb(0 0 0 / 25%), 0 10px 10px rgb(0 0 0 / 20%),
    0 20px 20px rgb(0 0 0 / 15%);
`;
